/* IMPORT */
import { OBSERVABLE_FALSE, OBSERVABLE_TRUE } from '../constants.js';
import cleanup from './cleanup.js';
import effect from './effect.js';
import isObservableFrozen from './is_observable_frozen.js';
import memo from './memo.js';
import untrack from './untrack.js';
import warmup from './warmup.js';
import { readable } from '../objects/callable.js';
import Observable from '../objects/observable.js';
import { is } from '../utils.js';
/* HELPERS */
const isEqualForSelector = (a, b) => {
    // Treat 0 and -0 as equal for selector purposes
    if ((a === 0 || is(a, -0)) && (b === 0 || is(b, -0)))
        return true;
    return is(a, b);
};
import { callStack, Stack } from './debugger.js';
/* HELPERS */
class DisposableMap extends Map {
    constructor() {
        super(...arguments);
        this.disposed = false;
    }
}
class SelectedObservable extends Observable {
    constructor() {
        super(...arguments);
        this.count = 1;
    }
    /* API */
    call() {
        if (this.selecteds.disposed)
            return;
        this.count -= 1;
        if (this.count)
            return;
        this.selecteds.delete(this.source);
    }
}
/* MAIN */
const selector = (source) => {
    /* NORMALIZING SOURCE */
    source = warmup(memo(source));
    /* FROZEN SOURCE */
    if (isObservableFrozen(source)) {
        const sourceValue = untrack(source);
        return (value) => {
            return (isEqualForSelector(value, sourceValue)) ? OBSERVABLE_TRUE : OBSERVABLE_FALSE;
        };
    }
    /* SELECTEDS */
    let selecteds = new DisposableMap();
    let selectedValue = untrack(source);
    const stack = callStack();
    effect((stack) => {
        const valuePrev = selectedValue;
        const valueNext = source();
        if (isEqualForSelector(valuePrev, valueNext))
            return;
        selectedValue = valueNext;
        selecteds.get(valuePrev)?.set(false);
        selecteds.get(valueNext)?.set(true);
    }, { suspense: false, sync: true, stack });
    /* CLEANUP ALL */
    const cleanupAll = () => {
        selecteds.disposed = true;
    };
    cleanup(cleanupAll);
    /* SELECTOR */
    return (value) => {
        /* INIT */
        let selected = selecteds.get(value);
        if (selected) {
            selected.count += 1;
        }
        else {
            const isSelected = isEqualForSelector(value, selectedValue);
            selected = new SelectedObservable(isSelected);
            selected.selecteds = selecteds;
            selected.source = value;
            selecteds.set(value, selected);
        }
        /* CLEANUP */
        cleanup(selected);
        /* RETURN */
        return readable(selected);
    };
};
/* EXPORT */
export default selector;
